<ng-container *ngComponentOutlet="logoComponent()" />
